import { COMEIN_URL } from '@/utils/host';

export const common = {
	// 通用接口
	phpUrl: COMEIN_URL + '/index.php',
	// 地区区号按首字母划分
	initialsAreaCode: COMEIN_URL + '/platform/json/tools/area-sort-letter'
};

export const shareholder = {
	getShareholderList: (market, code) =>
		`${COMEIN_URL}/irmcenter/anonymous/irstore/market/${market}/code/${code}/shareholder/number-of-accounts`, // 企业号股东户数
	getTopTenHoldings: (market, code) =>
		`${COMEIN_URL}/irmcenter/anonymous/irstore/market/${market}/code/${code}/shareholder/top-ten-holdings/v2`, // 企业号十大股东
	getTopTenHoldingsDate: (market, code) =>
		`${COMEIN_URL}/irmcenter/anonymous/irstore/market/${market}/code/${code}/shareholder/top-ten-holdings-date`, // 企业号十大股东 - 日期
	getInstitutionHoldingsDate: (market, code) =>
		`${COMEIN_URL}/irmcenter/anonymous/irstore/market/${market}/code/${code}/shareholder/institution-holdings-date`, // 企业号机构持股 - 日期
	getInstitutionHoldings: (market, code) =>
		`${COMEIN_URL}/irmcenter/anonymous/irstore/market/${market}/code/${code}/shareholder/institution-holdings/v2`, // 企业号机构持股
	getPreInstitutionHoldings: (market, code) =>
		`${COMEIN_URL}/irmcenter/anonymous/irstore/market/${market}/code/${code}/shareholder/institution-holdings` // 企业号机构持股(旧版H5)
};

export const stock = {
	getStockFundHolding: fullCode => `${COMEIN_URL}/irmcenter/anonymous/irstore/${fullCode}/stock/fund-holding`,
	getStockFundHoldingPage: fullCode =>
		`${COMEIN_URL}/irmcenter/anonymous/irstore/${fullCode}/stock/fund-holding/page`,
	getStockFundHoldingBarChart: fullCode =>
		`${COMEIN_URL}/irmcenter/anonymous/irstore/${fullCode}/stock/fund-holding/dividend-bar-chart`
};

export const financeData = {
	getMain: (marketType, code) => `${COMEIN_URL}/irmcenter/anonymous/irstore/${marketType}/${code}/main/indicators`,
	getLiabilities: (marketType, code) =>
		`${COMEIN_URL}/irmcenter/anonymous/irstore/${marketType}/${code}/assets/liabilities`,
	getCash: (marketType, code) => `${COMEIN_URL}/irmcenter/anonymous/irstore/${marketType}/${code}/cash/flow`,
	getProfit: (marketType, code) => `${COMEIN_URL}/irmcenter/anonymous/irstore/${marketType}/${code}/profit`
};

export const enterprise = {
	...shareholder,
	...stock,

	getPageDetail: (storeId, pageId) => `${COMEIN_URL}/irmcenter/anonymous/irstore/${storeId}/page/${pageId}`,
	getPageSaveContent: (storeId, pageId) => `${COMEIN_URL}/irmcenter/anonymous/irstore/${storeId}/innerPage/${pageId}`,
	news: storeId => `${COMEIN_URL}/irmcenter/anonymous/irstore/${storeId}/news`,
	newsDetail: (storeId, newsId) => `${COMEIN_URL}/irmcenter/anonymous/irstore/${storeId}/news/${newsId}`,
	reportList: `${COMEIN_URL}/irmcenter/anonymous/irstore/report/list`,
	researchReportDetail: () => `${COMEIN_URL}/irmcenter/anonymous/irstore/research-report-detail`,
	getAnnouncements: storeId => `${COMEIN_URL}/irmcenter/v2/anonymous/irstore/${storeId}/announcements`,
	getAnnouncementsByStock: fullCode => `${COMEIN_URL}/irmcenter/v3/anonymous/irstore/${fullCode}/announcements`,
	getAdvisoryList: `${COMEIN_URL}/irmcenter/anonymous/irm/store/advisory/list`,
	questionDetail: (storeId, uniqueCode, sourceBiz) =>
		`${COMEIN_URL}/irmcenter/anonymous/irstore/${storeId}/qa/${uniqueCode}/${sourceBiz}`,
	getCustomModuleContent: storeId => `${COMEIN_URL}/irmcenter/anonymous/irstore/${storeId}/moduleContent`,
	postAllActivityList: storeId => `${COMEIN_URL}/irmcenter/anonymous/irstore/${storeId}/clearance-activity/list`,
	getStockQuote: (market, code) => `${COMEIN_URL}/irmcenter/anonymous/irstore/market/${market}/code/${code}/quote`,
	queryRealTimeStockQuotation: `${COMEIN_URL}/irmcenter/open/store/sse-stock-quotation`, // 股票实时查询
	getStockDividendPlan: fullCode => `${COMEIN_URL}/irmcenter/anonymous/irstore/${fullCode}/stock/dividend-plan`,
	getStockYearDividend: fullCode => `${COMEIN_URL}/irmcenter/anonymous/irstore/${fullCode}/stock/dividend-bar-chart`,
	getDividendsSummary: storeId => `${COMEIN_URL}/irmcenter/anonymous/irstore/${storeId}/stock/dividend-plan/summary`,
	getStockNorthSouthFunds: fullCode =>
		`${COMEIN_URL}/irmcenter/anonymous/irstore/${fullCode}/stock/north-south-funds`,
	getStockMarginFunds: fullCode => `${COMEIN_URL}/irmcenter/anonymous/irstore/${fullCode}/stock/margin-funds`,
	getFinancialStatement: fullCode =>
		`${COMEIN_URL}/irmcenter/anonymous/irstore/${fullCode}/stock/financial-statement`,
	getProfitStatement: fullCode => `${COMEIN_URL}/irmcenter/anonymous/irstore/${fullCode}/stock/profit-statement`,
	getBalanceSheet: fullCode => `${COMEIN_URL}/irmcenter/anonymous/irstore/${fullCode}/stock/balance-sheet`,
	getCashFlowStatement: fullCode => `${COMEIN_URL}/irmcenter/anonymous/irstore/${fullCode}/stock/cash-flow-statement`,
	getQuarterPerformance: storeId => `${COMEIN_URL}/irmcenter/anonymous/irstore/${storeId}/quarter/performance`,
	getCommonIRStore: storeId => `${COMEIN_URL}/irmcenter/anonymous/irstore/${storeId}`,
	getKLineData: (fullCode, t) => `${COMEIN_URL}/irmcenter/anonymous/irstore/${fullCode}/stock/candlestick-chart/${t}`,
	getRoadshowList: storeId => `${COMEIN_URL}/irmcenter/anonymous/irstore/${storeId}/roadshow`,
	getActivityList: storeId => `${COMEIN_URL}/irmcenter/anonymous/irstore/${storeId}/activity`,
	getSurveyList: storeId => `${COMEIN_URL}/irmcenter/anonymous/irstore/${storeId}/summary`,
	annolink: 'json_irstore_annolink',
	createMessageContact: storeId => `${COMEIN_URL}/irmcenter/anonymous/irstore/${storeId}/message-contact`,
	getMessageMailCode: storeId => `${COMEIN_URL}/irmcenter/anonymous/irstore/${storeId}/message-contact/auth-code`,
	getModulesTabList: (storeId, pageId, moduleId) =>
		`${COMEIN_URL}/irmcenter/anonymous/irstore/${storeId}/page/${pageId}/customPageTab/${moduleId}`,
	apiPostScheduleList: storeId => `${COMEIN_URL}/irmcenter/anonymous/irstore/${storeId}/customs/calendar/schedule/v2`,
	apiGetIrstoreCalendarList: storeId => `${COMEIN_URL}/irmcenter/anonymous/irstore/${storeId}/customs/calendar/v2`,
	getScheduleLatestThree: storeId =>
		`${COMEIN_URL}/irmcenter/anonymous/irstore/${storeId}/customs/calendar/schedule/top-three/v2`,
	getScheduleRecentlyMonth: storeId =>
		`${COMEIN_URL}/irmcenter/anonymous/irstore/${storeId}/customs/calendar/schedule/recently-month`,
	apiPostScheduleDetail: storeId =>
		`${COMEIN_URL}/irmcenter/anonymous/irstore/${storeId}/customs/calendar/schedule/detail`,

	createLeaveWord: storeId => `${COMEIN_URL}/irmcenter/anonymous/irstore/${storeId}/leaveWord`,
	getLeaveWordConfig: storeId => `${COMEIN_URL}/irmcenter/anonymous/irstore/${storeId}/leaveWord/config/v2`,

	getDisplayModule: (storeId, pageId, moduleId) =>
		`${COMEIN_URL}/irmcenter/anonymous/irstore/${storeId}/page/${pageId}/displayModule/${moduleId}`,
	getPreviewDisplayModule: (storeId, pageId, moduleId) =>
		`${COMEIN_URL}/irmcenter/anonymous/irstore/${storeId}/page/${pageId}/displayModule/preview/${moduleId}`,
	getESGData: fullCode => `${COMEIN_URL}/irmcenter/anonymous/irstore/${fullCode}/esg`,
	getAnalystData: storeId => `${COMEIN_URL}/irmcenter/anonymous/irstore/${storeId}/analyst`,
	getAnalystDataSide: storeId => `${COMEIN_URL}/irmcenter/anonymous/irstore/${storeId}/analyst/side`,
	getCorporateData: storeId => `${COMEIN_URL}/irmcenter/anonymous/irstore/${storeId}/corporate`,
	getCorporateDetails: (storeId, businessId) =>
		`${COMEIN_URL}/irmcenter/anonymous/irstore/${storeId}/corporate/${businessId}`,
	getAnnouncementLink: `${COMEIN_URL}/personal/personal/irm/announcement-link/list`,

	allInstitutionList: COMEIN_URL + '/usercenter/manage/institution/list',

	getUsAnnouncementType: storeId => `${COMEIN_URL}/irmcenter/anonymous/irstore/${storeId}/us-announcement-type`,
	getUsAnnouncements: storeId => `${COMEIN_URL}/irmcenter/anonymous/irstore/${storeId}/us-announcements`,

	getRouteByToken: `${COMEIN_URL}/irmcenter/anonymous/irstore/get-route`,
	mainBusiness: fullCode => `${COMEIN_URL}/irmcenter/anonymous/irstore/${fullCode}/stock/main-business`,
	saveScreenshotImage: `${COMEIN_URL}/irmcenter/irstore/store-template/save-image`,
	getRecentlyList: storeId => `${COMEIN_URL}/irmcenter/anonymous/irstore/${storeId}/clearance-activity/recently-list`,

	getManyStock: fullCode => `${COMEIN_URL}/irmcenter/anonymous/irstore/${fullCode}/many-stock`,
	getMessageEvent: storeId => `${COMEIN_URL}/irmcenter/anonymous/irstore/${storeId}/message-event`,
	cancelEmail: storeId => `${COMEIN_URL}/irmcenter/anonymous/irstore/${storeId}/message-contact/cancel-email`,
	getMessageContactConfigV2: storeId => `${COMEIN_URL}/irmcenter/anonymous/irstore/${storeId}/message-contact/config/v2`,
};

export const rebuild = {
	queryModuleIdWithPageId: (storeId, pageId) =>
		`${COMEIN_URL}/irmcenter/anonymous/irstore/${storeId}/store-template/page/${pageId}`,
	queryTemplateConfig: (storeId, tmplId) =>
		`${COMEIN_URL}/irmcenter/anonymous/irstore/${storeId}/store-template/${tmplId}`,
	queryPageListWithTemplateId: (storeId, tmplId) =>
		`${COMEIN_URL}/irmcenter/anonymous/irstore/${storeId}/store-template/${tmplId}/page-list`
};
